<template>
  <!-- <div> -->
  <el-steps :direction="direction"
            :active="active"
            :simple="simple"
            v-bind="$attrs">
    <el-step v-for="(item,index) in steps"
             :key="index"
             :title="item.title"
             :icon="item.icon"
             :description="item.description">
    </el-step>
  </el-steps>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'sky-steps',
  props: {
    steps: {
      type: [Object, Array]
    },
    direction: {
      default: 'horizontal'
    },
    active: {
      type: Number,
    },
    simple: {
      require: false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>